import jQuery from "jquery";

// tslint:disable-next-line: completed-docs
export function intercomPosition(isMobile: boolean): void {
  const intercomLauncher = jQuery(document).find(".intercom-launcher");

  if (isMobile) {
    const url = window.location.href;
    if (url.includes("/book/") || url.includes("/booking")) {
      intercomLauncher.css({ display: "none" });
    } else {
      intercomLauncher.css({
        display: "block",
        "margin-bottom": "55px",
        "z-index": "100",
      });
    }
  } else {
    intercomLauncher.css({
      display: "block",
      "margin-bottom": "0",
      "z-index": "2147483647",
    });
  }
}
